import { render } from "./VignettePricingTable.vue?vue&type=template&id=3e132426"
import script from "./VignettePricingTable.vue?vue&type=script&setup=true&lang=js"
export * from "./VignettePricingTable.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/VignettePricingTable.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3e132426"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3e132426', __exports__)) {
    api.reload('3e132426', __exports__)
  }
  
  module.hot.accept("./VignettePricingTable.vue?vue&type=template&id=3e132426", () => {
    api.rerender('3e132426', render)
  })

}


export default __exports__